import { Store, StoreConfig } from '@datorama/akita';
import { createInitialUserCategoriesState, UserCategoriesState } from './user-categories.model';

@StoreConfig({ name: 'userCategories', resettable: true })
export class UserCategoriesStore extends Store<UserCategoriesState> {
  constructor() {
    super(createInitialUserCategoriesState());
  }
}

export const userCategoriesStore = new UserCategoriesStore();